import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import queryString from 'query-string';
import encodePathForUri from './pathUtil/encodePathForUri';

function initialize(_ref) {
  var disableAuthRedirect = _ref.disableAuthRedirect,
      routes = _ref.routes,
      microserviceId = _ref.microserviceId;
  var history = routes ? routes.history : undefined;
  var location = routes && routes.location ? routes.location : getLocation(history);

  var _queryString$parse = queryString.parse(location.search),
      environment = _queryString$parse.environment,
      cloudInstance = _queryString$parse.cloudInstance,
      server = _queryString$parse.server,
      accessToken = _queryString$parse.accessToken;

  var urlAuth = removeUndefined({
    token: accessToken || undefined,
    environmentName: environment || undefined,
    ecrionServer: cloudInstance || undefined,
    microserviceServer: server || undefined
  });
  var storedAuth = {
    ecrionServer: localStorage.getItem('ECRION.SERVER.URL') || undefined,
    microserviceServer: localStorage.getItem('MICROSERVICE.SERVER.URL') || undefined
  };

  if (urlAuth.environmentName) {
    storedAuth.token = localStorage.getItem('ECR.' + urlAuth.environmentName + '.AccessToken');
  } else {
    storedAuth.token = localStorage.getItem('ECR.EOS.AccessToken');
  }

  storedAuth = removeUndefined(storedAuth);
  removeTokenFromUrl(history, location);
  var specifiedAuth = removeUndefined({
    microserviceId: microserviceId || undefined
  });

  var auth = _objectSpread({}, storedAuth, urlAuth, specifiedAuth);

  ensureParametersInUrl(history, location, microserviceId, auth);
  auth.ecrionServer = addProtocol(auth.ecrionServer);
  auth.microserviceServer = addProtocol(auth.microserviceServer);
  auth = removeUndefined(auth);
  saveToStorage(_objectSpread({}, auth, {
    token: accessToken || undefined
  }));
  if (disableAuthRedirect) auth.disableAuthRedirect = disableAuthRedirect;
  return {
    data: auth,
    cleanup: function cleanup() {}
  };
}

function addProtocol(server) {
  if (server && !server.startsWith('http')) return 'https://' + server;
  return server;
}

function removeProtocol(server) {
  if (server && server.startsWith('https://')) return server.replace('https://', '');
  return server;
}

function saveToStorage(_ref2) {
  var token = _ref2.token,
      environmentName = _ref2.environmentName,
      ecrionServer = _ref2.ecrionServer,
      microserviceServer = _ref2.microserviceServer;

  if (token) {
    if (environmentName) localStorage.setItem('ECR.' + environmentName + '.AccessToken', token); //save last used token

    localStorage.setItem('ECR.EOS.AccessToken', token);
  }

  ecrionServer && localStorage.setItem('ECRION.SERVER.URL', ecrionServer);
  microserviceServer && localStorage.setItem('MICROSERVICE.SERVER.URL', microserviceServer);
}

function removeTokenFromUrl(history, location) {
  var searchParams = queryString.parse(location.search); // token from url

  if (!searchParams || !searchParams.accessToken) return;
  delete searchParams.accessToken;
  var newPath = location.pathname + '?' + stringifyQueryParams(searchParams) + location.hash;
  if (history && history.replace) history.replace(newPath);
}

function stringifyQueryParams(searchParams) {
  var custom = Object.keys(searchParams).filter(function (k) {
    return !isBuiltIn(k);
  }).reduce(function (o, k) {
    o[k] = searchParams[k];
    return o;
  }, {});
  var builtIn = Object.keys(searchParams).filter(isBuiltIn).reduce(function (o, k) {
    o[k] = searchParams[k];
    return o;
  }, {});
  var out = queryString.stringify(custom);
  if (out) out += '&';
  out += queryString.stringify(builtIn);
  return out;
}

function isBuiltIn(o) {
  return o === 'environment' || o === 'cloudInstance' || o === 'accessToken' || o === 'server';
}

function ensureParametersInUrl(history, location, microserviceId, auth) {
  location = location || getLocation(history);
  var searchParams = queryString.parse(location.search); // token from url

  if (!searchParams) searchParams = {};
  if (auth.environmentName && searchParams.environment !== auth.environmentName) searchParams.environment = auth.environmentName;
  if (microserviceId && auth.ecrionServer && searchParams.cloudInstance !== auth.ecrionServer) searchParams.cloudInstance = removeProtocol(auth.ecrionServer);
  if (searchParams.accessToken) delete searchParams.accessToken;
  var query = stringifyQueryParams(searchParams);
  if (query) query = '?' + query;
  var encodedPathName = encodePathForUri(location.pathname);
  var newPath = encodedPathName + query + location.hash;
  if (history && history.replace) history.replace(newPath);
}

function getLocation(history) {
  var location = history ? history.location : window.location;
  return location;
}

function removeUndefined(obj) {
  var obj2 = {};
  Object.keys(obj).forEach(function (key) {
    if (obj[key] !== undefined) obj2[key] = obj[key];
  });
  return obj2;
}

export default {
  initialize: initialize,
  saveToStorage: saveToStorage,
  ensureParametersInUrl: ensureParametersInUrl
};